import React, { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import cookie from '../utilities/cookie';
import { changeRequiredPassword } from '../actions/authActions';

interface Props {
    dispatch: Function;
}

const PasswordChangeRequired: React.FC<Props> = ({ dispatch }) => {

    const [platform] = useState(cookie.get('pending_platform') || cookie.get('last_platform') || '');
    const [login] = useState(cookie.get('pending_login') || '');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(changeRequiredPassword(login, platform, currentPassword, newPassword, confirmPassword));
    };

    return (
        <div className="auth-page">

            <Container className="d-flex align-items-center justify-content-center">

                <Row className="w-100 justify-content-center">
                    <Col md={5} lg={4}>

                        <Card className="auth-card border-0 shadow-lg">

                            <Card.Body className="p-5" style={{maxHeight: '90vh', overflowY: 'auto'}}>

                                <div className="text-center mb-4">

                                    <h3 className="fw-bold mb-2">
                                        Update your password
                                    </h3>

                                    <p className="text-muted small">
                                        Your password has expired or is temporary.
                                        Please choose a new secure password.
                                    </p>

                                </div>

                                <Form onSubmit={onSubmit} className="text-start mb-4">

                                    <div className="mb-2">

                                        <Form.Label className="text-muted small">
                                            Platform: {platform}
                                        </Form.Label>

                                    </div>

                                    <div className="mb-4">

                                        <Form.Label className="text-muted small">
                                            Username: {login}
                                        </Form.Label>

                                    </div>

                                    <div className="mb-3">

                                        <Form.Label>Current password</Form.Label>

                                        <Form.Control
                                            type="password"
                                            placeholder="Enter current password"
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value)}
                                            required
                                        />

                                    </div>

                                    <div className="mb-3">

                                        <Form.Label>New password</Form.Label>

                                        <Form.Control
                                            type="password"
                                            placeholder="Enter new password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />

                                    </div>

                                    <div className="mb-4">

                                        <Form.Label>Confirm new password</Form.Label>

                                        <Form.Control
                                            type="password"
                                            placeholder="Confirm new password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                        />

                                    </div>

                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="w-100 mb-3"
                                        size="lg"
                                    >
                                        Update Password
                                    </Button>

                                    <Button
                                        variant="link"
                                        className="w-100 text-muted"
                                        onClick={() => window.location.href = '/login'}
                                    >
                                        Back to Login
                                    </Button>

                                </Form>

                            </Card.Body>

                        </Card>

                    </Col>
                </Row>

            </Container>

        </div>
    );
};

export default connect()(PasswordChangeRequired);
